import React, { useState, useEffect } from 'react';
import { Card, Col, Row, Button, Spinner, Modal } from 'react-bootstrap';
import { Form } from 'react-bootstrap';
import useFormGenerator from '../../common/FormUtils';
import useHeaderGenerator from '../../common/functions/useHeaderGenerator';
import useButtonsGenerator from '../../common/functions/useButtonsGenerator';
import { useParams } from 'react-router-dom';
import FormModal from '../../common/FormModal';
import ProgramService from './ProgramService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRobot } from '@fortawesome/free-solid-svg-icons';
import schema from './jsonSchema';
import { Badge } from 'react-bootstrap';
import ImportFromPDF from './ImportFromPDF';
import is from 'is_js';
import ProgrammingService from '../programming/ProgrammingService';
const jsonSchema = schema;

const mergedJsonSchema = (jsonSchema, typeOptions) => {
  return jsonSchema.map(field => {
    if (field.type === 'group') {
      return {
        ...field,
        fields: field.fields.map(f => assignValueToJsonSchema(f, typeOptions))
      };
    } else {
      return assignValueToJsonSchema(field, typeOptions);
    }
  });
};

const assignValueToJsonSchema = (field, typeOptions) => {
  if (field.name === 'type') {
    return {
      ...field,
      options: typeOptions
    };
  }
  return field;
};

const ProgramForm = () => {
  const { identifier } = useParams();
  const [data, setData] = useState();
  const [modalShow, setModalShow] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [availableClasses, setAvailableClasses] = useState([]);
  const convertToOptions = text => {
    const arrayOfInterests = text.split(',').map(i => i.trim());
    if (text) {
      return arrayOfInterests.map(i => ({ value: i, label: i }));
    }
    return [];
  };
  useEffect(() => {
    if (undefined !== identifier) {
      ProgramService.retrieveProgram(identifier)
        .then(data => {
          console.log('Retrieved Program:', data);
          const updatedData = {
            ...data,
            tags: data.tags ? convertToOptions(data.tags) : [],
            exercises: data.exercises ? convertToOptions(data.exercises) : [],
            type: data.type ? { value: data.type, label: data.type } : null
          };
          setData(updatedData);
        })
        .catch(error => console.log(error));
    }
    let availableTypes = [];
    ProgrammingService.getTypes().then(types => {
      console.log('Available types:', types);
      types.map(type => {
        availableTypes.push({ label: type, value: type });
      });
      setAvailableClasses(availableTypes);
    });
  }, [identifier]);

  const handleProgramFormSubmit = formData => {
    const updatedFormData = {
      ...formData,
      type: formData.type.value,
      global: formData.global === undefined ? false : formData.global
    };
    ProgramService.saveProgram(updatedFormData)
      .then(response => {
        console.log(response);
        setModalShow(true);
      })
      .catch(error => console.log(error));
  };

  const buttonsConf = [
    {
      name: 'Save Program',
      type: 'submit',
      variant: 'info',
      onClick: () => {
        console.log('Save Program');
      }
    },
    {
      name: 'Cancel',
      type: 'button',
      variant: 'secondary',
      onClick: () => {
        console.log('Cancel');
        setShowForm(false);
      }
    }
  ];
  const headerTitle = identifier ? 'Edit Program' : 'Create Program';
  const headerDescription = identifier
    ? 'Edit the details of your Program'
    : 'Fill in the details of your new Program';
  const headerGenerated = useHeaderGenerator(
    headerTitle,
    headerDescription,
    []
  );
  return (
    <>
      {headerGenerated}
      {modalShow && (
        <FormModal
          message={'Program  has been updated!'}
          modalShow={modalShow}
          setModalShow={setModalShow}
          redirectUrl="/app/wod/programs"
        />
      )}
      <Card>
        <Card.Body>
          {data || undefined === identifier ? (
            // Pass data to the form generator hook
            <FormGeneratorWithData
              data={data}
              buttonsConf={buttonsConf}
              onSubmit={handleProgramFormSubmit}
              typeOptions={availableClasses}
            />
          ) : (
            <p>Loading...</p>
          )}
        </Card.Body>
      </Card>
    </>
  );
};
const FormGeneratorWithData = ({
  data,
  buttonsConf,
  onSubmit,
  typeOptions
}) => {
  const [validated, setValidated] = useState(false);
  const buttonsGenerated = useButtonsGenerator(buttonsConf);
  // Use the useFormGenerator hook with the provided data
  const { formFields, handleSubmit, handleChange } = useFormGenerator(
    mergedJsonSchema(jsonSchema, typeOptions),
    onSubmit,
    data,
    setValidated
  );

  // Render your form using the formFields and event handlers
  return (
    <Form
      className="mb-2"
      noValidate
      validated={validated}
      onSubmit={handleSubmit}
    >
      {formFields}
      <Card.Footer>{buttonsGenerated}</Card.Footer>
    </Form>
  );
};
export default ProgramForm;
